import { api } from "./api";

/* Cities, Localities, Builders API client. UI shape == API shape (these
   are simple master-data records). */

export const citiesApi = {
  async list(includeInactive = false) {
    const r = await api.get(`/cities${includeInactive ? "?includeInactive=true" : ""}`);
    return Array.isArray(r) ? r : [];
  },
  async create(payload) {
    return api.post("/cities", payload);
  },
  async update(id, patch) {
    return api.patch(`/cities/${id}`, patch);
  },
  async delete(id) {
    return api.delete(`/cities/${id}`);
  },
};

export const localitiesApi = {
  async list({ cityId, includeInactive = false } = {}) {
    const params = new URLSearchParams();
    if (cityId) params.set("cityId", cityId);
    if (includeInactive) params.set("includeInactive", "true");
    const qs = params.toString();
    const r = await api.get(`/localities${qs ? `?${qs}` : ""}`);
    return Array.isArray(r) ? r : [];
  },
  async create(payload) {
    return api.post("/localities", payload);
  },
  async update(id, patch) {
    return api.patch(`/localities/${id}`, patch);
  },
  async delete(id) {
    return api.delete(`/localities/${id}`);
  },
};

export const buildersApi = {
  async list(includeInactive = false) {
    const r = await api.get(`/builders${includeInactive ? "?includeInactive=true" : ""}`);
    return Array.isArray(r) ? r : [];
  },
  async create(payload) {
    return api.post("/builders", payload);
  },
  async update(id, patch) {
    return api.patch(`/builders/${id}`, patch);
  },
  async delete(id) {
    return api.delete(`/builders/${id}`);
  },
  async reorder(ids) {
    return api.post("/builders/reorder", { ids });
  },
};
